"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var astrocite_core_1 = require("astrocite-core");
var constants_1 = require("./constants");
var parser = require("./grammar");
var curriedDate = function () { return function (first) {
    if (first === void 0) { first = { value: '' }; }
    return function (second) {
        if (second === void 0) { second = { value: '' }; }
        if (!first.kind)
            return;
        return first.kind === 'year'
            ? { issued: { 'date-parts': [[first.value, second.value, '']] } }
            : { issued: { 'date-parts': [[second.value, first.value, '']] } };
    };
}; };
var parseValue = function (value, macros) {
    var output = '';
    var input = Array.isArray(value) ? value : [value];
    try {
        for (var input_1 = __values(input), input_1_1 = input_1.next(); !input_1_1.done; input_1_1 = input_1.next()) {
            var v = input_1_1.value;
            switch (v.kind) {
                case 'Text':
                case 'Number':
                    output += v.value;
                    break;
                case 'String':
                    output += macros.get(v.value) || '';
                    break;
                case 'NestedLiteral':
                    output += parseValue(v.value, macros);
                    break;
                case 'RegularCommand':
                case 'SymbolCommand':
                    output += "" + (constants_1.KNOWN_COMMANDS.get(v.value) || '');
                    break;
                case 'DicraticalCommand':
                    output += "" + v.character + constants_1.DICRATICS.get(v.mark);
                    break;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (input_1_1 && !input_1_1.done && (_a = input_1.return)) _a.call(input_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return output;
    var e_1, _a;
};
var parseEntry = function (node, macros) {
    var entry = {
        id: node.id,
        type: constants_1.TYPE_MAP.get(node.type) || 'article',
    };
    var date = curriedDate();
    try {
        for (var _a = __values(node.properties), _b = _a.next(); !_b.done; _b = _a.next()) {
            var property = _b.value;
            switch (property.key) {
                case 'year':
                case 'month':
                    date = date({
                        kind: property.key,
                        value: parseValue(property.value, macros),
                    });
                    break;
                case 'author':
                case 'editor':
                    entry = __assign({}, entry, (_c = {}, _c[property.key] = parseValue(property.value, macros)
                        .split(/ and (?:others)?/g)
                        .filter(Boolean)
                        .map(astrocite_core_1.parseName), _c));
                    break;
                default:
                    var field = constants_1.FIELD_MAP.get(property.key);
                    if (field) {
                        entry = __assign({}, entry, (_d = {}, _d[field] = parseValue(property.value, macros), _d));
                    }
            }
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (_b && !_b.done && (_e = _a.return)) _e.call(_a);
        }
        finally { if (e_2) throw e_2.error; }
    }
    while (typeof date === 'function') {
        date = date();
    }
    return __assign({}, entry, date ? date : {});
    var e_2, _e, _c, _d;
};
function parseCSL(source) {
    var STRINGS_MAP = new Map(constants_1.KNOWN_MACROS);
    var ast = parser.parse(source);
    var csl = [];
    try {
        for (var _a = __values(ast.children), _b = _a.next(); !_b.done; _b = _a.next()) {
            var node = _b.value;
            switch (node.kind) {
                case 'StringExpression':
                    STRINGS_MAP.set(node.key, parseValue(node.value, STRINGS_MAP));
                    break;
                case 'Entry':
                    csl = __spread(csl, [parseEntry(node, STRINGS_MAP)]);
                    break;
                default:
                    continue;
            }
        }
    }
    catch (e_3_1) { e_3 = { error: e_3_1 }; }
    finally {
        try {
            if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
        }
        finally { if (e_3) throw e_3.error; }
    }
    return csl;
    var e_3, _c;
}
exports.default = parseCSL;
